import React, { useState } from 'react'
import { ShowSupportPartnersContext } from './types'
import { DefaultSupportPartnerInterface, SupportPartnerInterface } from '../types'
import { FaChevronCircleLeft, FaPlus } from 'react-icons/fa'
import { useNavigate } from 'react-router'
import AddSupportAssModal from './AddSupportPartnerModal'
import DataSupportPartner from './DataSupportPartner'
import EditSupportAssModal from './EditSupportPartnerModal'
import SuccessMsg from '../../../Messages/SuccessMsg'
import DeleteSupportAssModal from './DeleteSupportPartnerModal'

const ShowSupportPartner = () => {
  const [showSuccessMsg, setShowSuccessMsg] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [showAddModal, setShowAddModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [selectedSupportAss, setSelectedSupportAss] = useState<SupportPartnerInterface>(DefaultSupportPartnerInterface)

  const navigate = useNavigate()

  return (
    <ShowSupportPartnersContext.Provider value={{
      showSuccessMsg, setShowSuccessMsg,
      showEditModal, setShowEditModal,
      showAddModal, setShowAddModal,
      showDeleteModal, setShowDeleteModal,
      selectedSupportAss, setSelectedSupportAss
    }}>
      {showSuccessMsg && <SuccessMsg modal={showSuccessMsg} toggle={() => setShowSuccessMsg(!showSuccessMsg)}/> }

      <div className="flex justify-start gap-2 mt-2">
        <FaChevronCircleLeft className='text-main mt-2' style={{ fontSize: "30px" }} onClick={() => { 
          navigate(`/partners`)
        }} /> 
        <button className="p-2 rounded btn-main" onClick={() => setShowAddModal(!showAddModal)}>
          <FaPlus />
        </button>
      </div>
      <AddSupportAssModal modal={showAddModal} toggle={() => setShowAddModal(!showAddModal)}/>
      {showEditModal && 
        <EditSupportAssModal modal={showEditModal} toggle={() => setShowEditModal(!showEditModal)}/>
      }
      {showDeleteModal && 
        <DeleteSupportAssModal modal={showDeleteModal} toggle={() => setShowDeleteModal(!showDeleteModal)}/>
      }
      <DataSupportPartner />
    </ShowSupportPartnersContext.Provider>
  )
}

export default ShowSupportPartner